// package Imports
import { toJS } from "mobx";

// Project Imports
import SPRM_ENUM from "constants/SPRM_constants";
import StorageKeys from "constants/StorageKeys";
import * as API from "constants/API";
import axios from "axios";
import QmsStorageKeys from "constants/QmsStorageKeys";
import AuthStore from "modules/login/store/AuthStore";
import { BANCA_JOURNEY, SAMS_JOURNEY } from "constants/Constants";
import getSpDetailsForSams from "./getSpDetailsForSams";

const savePragatiNAInboundData = (location) => {
    let agent_id;

    const urlParams = new URLSearchParams(location.search);
    const source_system = urlParams.get("source");
    //agent_id = urlParams.get(SPRM_ENUM.AGENT_ID)
    agent_id = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE)

    if (agent_id) {

        localStorage.setItem(StorageKeys.AGENT_ID, agent_id)

        const getPragatiNaInboundData = async () => {
            let sourceFrom = toJS(AuthStore.sourceFrom)
            let url = ""
            if (sourceFrom !== "Distribution_App") {
                url = API.PRAGATI_INBOUND_DATA
            } else {
                url = API.DISTRIBUTED_APP_INBOUND_DATA
            }
            const response = await axios(url + `?agent_id=${agent_id}`);
            console.log("PRAGATI_INBOUND_DATA ::::", response.data);
            localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, true);
            localStorage.setItem(StorageKeys.PRAGATI_HOME_URL, response.data.home_url)
            localStorage.setItem(StorageKeys.PRAGATI_POST_CALL_END_POINT_URL, response.data.post_call_end_point)
            localStorage.setItem(StorageKeys.START_APPLICATION_END_POINT_URL, response.data.start_app_end_point)
            localStorage.setItem(QmsStorageKeys.START_APPLICATION_END_POINT_URL, response.data.start_app_end_point)
            localStorage.setItem(StorageKeys.LOGIN_CODE, response.data.login_code)
            localStorage.setItem(StorageKeys.VENDOR, response.data.vendor_code)
            localStorage.setItem(StorageKeys.SOURCE_FROM, "NA")
            localStorage.setItem(StorageKeys.LOGIN_AGENT_CODE, response.data.login_agent_code)
            if (source_system === BANCA_JOURNEY || source_system === SAMS_JOURNEY) {
                localStorage.setItem(StorageKeys.AGENT_NAME, response.data.agent_name);
                localStorage.setItem(StorageKeys.AGENT_CODE, response.data.login_code);
                if (location?.pathname !== "/choose-needs") {
                    getSpDetailsForSams()
                }
            }
        };

        getPragatiNaInboundData();
    }

}

export default savePragatiNAInboundData